import React from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, bool, shape, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import SocialMediaLinks from 'Pods/Shared/SocialMedia/SocialMediaLinks'
import SvgTriangleUIIcon from 'Pods/Shared/SvgTriangleUIIcon'

import FooterPresentation from './Components/FooterPresentation'
import LocaleSelector from './LocaleSelector'

class Footer extends React.Component {
  state = { showDiscounts: false, currentPathname: '/', currentQuery: '' }

  componentDidMount() {
    this.checkDiscounts()
    this.setState({
      currentPathname: window.location.pathname,
      currentQuery: window.location.search.replace(/^\?/, ''),
    })
  }

  checkDiscounts() {
    if (window.App?.config?.discounts) {
      this.setState({ showDiscounts: true })
      return
    }

    if (window.App?.events?.subscribe) {
      window.App.events.subscribe('app:config:load', (data) => {
        if (data?.discounts) {
          this.setState({ showDiscounts: true })
        }
      })
    }
  }

  renderLinks = () => {
    const { locale } = this.props
    const { showDiscounts } = this.state

    const links = i18n.t('footer.links', {
      ns: 'rails',
      returnObjects: true,
      lng: locale,
    })

    const defaultLinks = i18n.t('footer.links', {
      ns: 'rails',
      returnObjects: true,
      lng: 'en',
    })

    if (showDiscounts && links.buyLinks) {
      links.buyLinks.push({
        text: i18n.t('navigation.3d-models.discounts', {
          ns: 'rails',
          lng: locale,
        }),
        link: '/3d-models?sale_off=1',
      })
    }

    const canRenderLinks = typeof links === 'object' && links !== null
    const linksKeys = canRenderLinks ? Object.keys(links) : []

    if (!canRenderLinks) return null

    return (
      <div className="responsive-footer__navigation-row row">
        {linksKeys.map((sectionKey, sectionIndex) => {
          const sectionLinks = links[sectionKey] || []
          const defaultSectionLinks = defaultLinks && defaultLinks[sectionKey]

          const hasDefaultSectionLinks =
            Array.isArray(defaultSectionLinks) && defaultSectionLinks.length > 0

          return (
            <div
              key={`footer-links-${sectionKey}`}
              className="responsive-footer__col col-12 col-sm-6 col-md"
            >
              <ul className="responsive-footer__navigation">
                {sectionLinks.map((link, index) => {
                  const isMainLink = index === 0
                  const showDropdownIcon =
                    isMainLink && sectionIndex < linksKeys.length - 1

                  const trackLabel =
                    hasDefaultSectionLinks && defaultSectionLinks[0]
                      ? defaultSectionLinks[0].text
                      : link.text

                  const trackText =
                    hasDefaultSectionLinks && defaultSectionLinks[index]
                      ? defaultSectionLinks[index].text
                      : link.text

                  const isFirstItemLastColumn =
                    index === 0 && sectionIndex === linksKeys.length - 1
                  const LinkWrapper = isFirstItemLastColumn ? 'span' : 'a'

                  return (
                    <li key={`footer-${link.text}`}>
                      <LinkWrapper
                        className={classnames(
                          'link',
                          isMainLink && 'link--main'
                        )}
                        data-track-label={trackLabel}
                        data-track-text={trackText}
                        href={link.link}
                      >
                        {link.text}
                        {showDropdownIcon && (
                          <SvgTriangleUIIcon
                            type="arrowRightUp"
                            color="light"
                            size="small"
                            className="responsive-footer__arrow-right-up"
                          />
                        )}
                      </LinkWrapper>
                    </li>
                  )
                })}
              </ul>
            </div>
          )
        })}
      </div>
    )
  }

  render() {
    const { locale, localeUrls } = this.props
    const { currentPathname, currentQuery } = this.state
    const currentYear = new Date().getFullYear()

    return (
      <footer id="app-footer" className="responsive-footer">
        <div className="responsive-footer__content">
          <FooterPresentation />
          <div className="responsive-footer__middle-row row">
            <div className="col-12">{this.renderLinks()}</div>
          </div>
        </div>

        <div className="cgt-divider responsive-footer__divider">
          <div className="cgt-divider__color" />
        </div>

        <div className="responsive-footer__bottom-row row">
          <div className="responsive-footer__col-privacy">
            <ul className="responsive-footer__bottom-navigation">
              <li className="responsive-footer__bottom-description full-width">
                {`© CGTrader 2011-${currentYear}`}
              </li>
              <li className="responsive-footer__bottom-description full-width">
                UAB CGTrader, Antakalnio st. 17, Vilnius, Lithuania
              </li>
              <li className="responsive-footer__bottom-description">
                <a
                  className="link"
                  href="/pages/terms-and-conditions"
                  data-track-label="Terms & Conditions"
                  data-track-text="Terms & Conditions"
                >
                  {i18n.t('footer.bottom-row.terms-link', {
                    ns: 'rails',
                    lng: locale,
                  })}
                </a>
              </li>
              <li className="responsive-footer__bottom-description">
                <a
                  className="link"
                  href="/pages/privacy-policy"
                  data-track-label="Privacy"
                  data-track-text="Privacy"
                >
                  {i18n.t('footer.bottom-row.privacy', {
                    ns: 'rails',
                    lng: locale,
                  })}
                </a>
              </li>
              <li className="responsive-footer__bottom-description">
                <LocaleSelector
                  activeLocale={locale}
                  currentPathname={currentPathname}
                  currentQuery={currentQuery}
                  localeUrls={localeUrls}
                />
              </li>
            </ul>
          </div>
          <SocialMediaLinks />
        </div>
      </footer>
    )
  }
}

Footer.propTypes = {
  isReduced: bool,
  locale: string,
  localeUrls: arrayOf(shape({ locale: string, url: string })),
}

Footer.defaultProps = {
  isReduced: false,
  locale: 'en',
  localeUrls: [],
}

export default Footer
